import { startLoading, stopLoading } from "./loading";

export const API = import.meta.env.VITE_API_URL || "http://localhost:8082/api/mini-admin";

export async function fetchJson<T>(url: string): Promise<T | null> {
  startLoading();
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const text = await res.text();
    if (!text || text === "null") return null;
    return JSON.parse(text) as T;
  } catch {
    return null;
  } finally {
    stopLoading();
  }
}
